import {styled} from "@mui/material/styles";
import {SwitchProps} from "@mui/material";
import SwitchStyled from "./SwitchStyled";

export default styled(SwitchStyled)<SwitchProps>(({theme}) => ({
    "& .MuiSwitch-track": {
        backgroundColor: theme.palette.primary.main,
    },
}));
